import $ from "jquery";

class ProductThumbsSlider {
    constructor($el) {
        let imageLarge = document.querySelector('.product-images__large');
        this.$el = $el;

        this.options = {
            // autoPlay: true,
            cellAlign: 'left',
            pageDots: false,
            wrapAround: true,
            prevNextButtons: true,
            freeScroll: true,
            cellSelector: '.product-images__thumbnails-item',
            imagesLoaded: true,
        };

        if(this.$el.length) {

            if (this.$el[0].children.length > 4) {
                this._createSlider();
                this.$el[0].parentNode.classList.add('thumbs-slider--active');
                this.$el[0].classList.remove('no-slider');
                imageLarge.classList.remove('no-slider');
            }

        }
    }

    _createSlider() {
        this.$el.flickity(this.options);
    }
}

export default ProductThumbsSlider;
